import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_API = `${BACKEND_URL}/api/admin`;
const TOKEN_KEY = "hub_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({ baseURL: ADMIN_API });

adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function login(email, password) {
  const { data } = await adminApi.post("/login", { email, password });
  setToken(data.access_token);
  return data;
}

export async function me() {
  const { data } = await adminApi.get("/me");
  return data.admin;
}

export async function changePassword(current_password, new_password) {
  const { data } = await adminApi.post("/change-password", {
    current_password,
    new_password,
  });
  return data;
}

export async function stats() {
  const { data } = await adminApi.get("/stats");
  return data;
}

export async function listDiagnostics(params) {
  const { data } = await adminApi.get("/diagnostics", { params });
  return data;
}

export async function getDiagnostic(id) {
  const { data } = await adminApi.get(`/diagnostics/${id}`);
  return data;
}

export async function updateDiagnostic(id, patch) {
  const { data } = await adminApi.patch(`/diagnostics/${id}`, patch);
  return data;
}

export async function options() {
  const { data } = await adminApi.get("/options");
  return data;
}

export function exportUrl(kind) {
  const t = getToken();
  return `${ADMIN_API}/export.${kind}?token=${encodeURIComponent(t || "")}`;
}

export async function downloadExport(kind) {
  const res = await adminApi.get(`/export.${kind}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  a.download = `diagnosticos-hub-${stamp}.${kind}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const publicReportUrl = (id) =>
  `${BACKEND_URL}/api/diagnostics/${id}/report`;
